export default __webpack_public_path__ + "static/media/choosed.24f29409.svg";